import * as libLocation from "./lib/location.ts";
import * as Html from "./util/Html.ts";
import * as amplify from "./util/amplify.ts";
import * as DarkMode from "./DarkMode.ts";
import "./lib/Screen.js";
import "./lib/FileUtils.ts";
import "./lib/tooltip.ts";

Html.register({
  print(){
    window.print();
  },
  darkmode(val){
    this.parent().children().removeClass('selected')
    this.addClass('selected')
    DarkMode.changePreference(val)
  },
  goto(page){
    page = page.replace('$metaId',this.metaId());
    libLocation.goTo(page);
  },
  openurl(page){
    window.open(page,"_blank");
  },
  goback(page){
    if(page){
      libLocation.goBack(page);
    }else{
      history.back();
    }
  },
  "refresh":function(){
    libLocation.refresh();
  },
  "submit":function(){
    this.trigger('submit');
  },
  "reset":function(){
    this.parents('form').trigger('reset');
  },
  "amplify":function(name){
    amplify.publish(name)
  },
  stoppropagation(){
    return true;
  },
  toogleparent(parentSelector,className){
    this.parents(parentSelector).each(function(k,o){
      $(o).toggleClass(className);
    });
  },
  addparentclass(parentSelector,className){
    this.parents(parentSelector).each(function(k,o){
      $(o).addClass(className);
    });
  },
  clickprev(){
    this.prev().click();
  },
  accordionclick(){
    this.parent().nextAll().toggle()
    this.toggleClass('rotate180')
  },
  mailto(email){
    window.location = 'mailto:'+email;
  }
  
});